import _ from 'underscore';
import { CacheIndex } from './base';

export class ResourceCacheIndex extends CacheIndex {
  /**
   * Index of cache entries. Keep track which keys are in the cache, and provide
   * query methods to query all keys associated with certain resource.
   * @param {TimeAwareCache} cache - The cache to index
   */
  constructor(cache) {
    super(cache);
    this.indices = {};
  }

  /**
   * Add a cache key to the index
   * @override
   * @param {string} key - The key to add
   * @returns {void}
   */
  add(key) {
    const { resource } = JSON.parse(key);
    if (!_.has(this.indices, resource)) {
      this.indices[resource] = {};
    }
    this.indices[resource][key] = true;
  }

  /**
   * Remove a cache key from the index
   * @override
   * @param {string} key - The key to remove
   * @returns {void}
   */
  del(key) {
    const { resource } = JSON.parse(key);
    if (_.has(this.indices, resource)) {
      delete this.indices[resource][key];
      if (_.isEmpty(this.indices[resource])) {
        delete this.indices[resource];
      }
    }
  }

  /**
   * Query the cached keys associated with a certain resource (entity type)
   * @override
   * @param {Object} query - The query object
   * @returns {string[]} - The keys matches the query
   */
  keys({ resource }) {
    return _.chain(this.indices).result(resource, {}).keys().value();
  }
}
